import React, { useEffect, useState } from 'react';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Show after 33 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 33 * 1000);
    return () => clearTimeout(timer);
  }, []);
  return <div className={`fixed bottom-0 left-0 w-full bg-[rgba(255,255,255,0.98)] p-[10px_15px] shadow-[0_-5px_20px_rgba(0,0,0,0.15)] z-[9999] flex items-center justify-between transition-transform duration-300 border-t-[2px] border-[#8B4513] md:hidden ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} id="sticky-cta" data-id="element-247">
      <div className="text-left flex-1" data-id="element-248">
        <div className="text-[10px] uppercase text-[#6B7280] font-[700]" data-id="element-249">
          📖 La Biblia del Café
        </div>
        <div className="flex items-baseline gap-[6px]" data-id="element-250">
          <div className="font-[800] text-[18px] text-[#374151]" data-id="element-251">$6.37</div>
          <div className="text-[11px] text-[#EF4444] font-[600] line-through" data-id="element-252">
            $19.99
          </div>
        </div>
      </div>
      <a href="#elige-tu-plan" className="bg-gradient-to-br from-[#8B4513] to-[#654321] text-white no-underline font-[900] px-[20px] py-[12px] rounded-[50px] text-[13px] uppercase" data-id="element-253">
        DESCARGAR ➤
      </a>
    </div>;
}